<div class="bn-dialog bn-shield-white-label-page-modal p-0">
  <div
    class="bn-dialog__close"
    (click)="onClose()">
    <fa-icon
      aria-label="Close"
      icon="xmark"
      size="lg"></fa-icon>
  </div>
  <div class="bn-dialog__title">{{ config.title }}</div>
  <p class="text-dark-6 mt-1 mb-0 px-4">{{ config.description }}</p>

  <div class="bn-dialog__editor__title d-flex align-items-center justify-content-between">
    <span class="text-100-semi-bold text-dark-6 text-uppercase">Response body</span>
    <button
      bn-web-ui-button
      itemStyle="stroke"
      size="sm"
      type="button"
      [disabled]="!hasCustomPage"
      (click)="onResetToDefault()">
      Reset to default
    </button>
  </div>

  <div class="bn-dialog__body">
    <div class="bn-shield-white-label-page-modal__additional-code"><code>&lt;body&gt;</code></div>
    <ngs-code-editor
      theme="vs-dark"
      [codeModel]="codeModel"
      [options]="codeEditorOptions"
      (valueChanged)="form.controls.htmlContent.setValue($event)"></ngs-code-editor>
  </div>
  <div class="bn-shield-white-label-page-modal__additional-code"><code>&lt;/body&gt;</code></div>
  <div class="bn-dialog__actions d-flex justify-content-end gap-2 mt-4">
    <button
      bn-web-ui-button
      itemStyle="stroke"
      size="lg"
      type="button"
      (click)="onClose()">
      Cancel
    </button>
    <button
      bn-web-ui-button
      itemStyle="primary"
      size="lg"
      type="button"
      (click)="onSave()">
      Save page
    </button>
  </div>
</div>
